import { render, staticRenderFns } from "./DeletePortalUserModal.vue?vue&type=template&id=5b379bc8&"
import script from "./DeletePortalUserModal.vue?vue&type=script&lang=js&"
export * from "./DeletePortalUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports